import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames";

import { MobileViewCompProps } from "@/interfaces/CompanyProfile";
import { isNotUndefined } from "@/shared/FunctionCore";
import "@/styles/AppHeaderStyles.scss"
import { Link } from "react-router-dom";
import { AppContext, ContextType } from "@/shared/context";
import { useTranslation } from "react-i18next";
import homepageLogo from "@/resources/original/logo-dnb.svg";
import mobileToggleButton from "@/resources/optimized/icon-menu.svg";
import mobileCloseButton from "@/resources/optimized/icon-menu-close.svg";
import { t } from "i18next";
import { loginMenuLinks } from "@/components/header/content";
import { ChevronLeftSvg } from "@/resources/chevron-left";
import { businessCreditURL, businessGrowthURL, businessRiskURL, dunsNumberMythsURL, dunsNumberURL, enterpriseURL, globeHeaderIconURL, publicSectorURL, resourcesHeaderURL, serviceCenterURL } from "@/shared/constant";

type MenuItem = {
    label: string;
    children?: MenuItem[];
    class?: string;
    url?: string;
    onNewTab?: boolean;
    linkTag?: boolean;
};

const menuData: MenuItem[] = [
    {
        label: 'Search Options',
        children: [
            { label: t("businessDirectory.siteContentTab"), class: 'sub-menu search-sub-menu', url: "/site-search-results.html", linkTag: true },
            { label: t("businessDirectory.bdBrowserTabTitle"), class: 'sub-menu search-sub-menu', url: "/", linkTag: true },
            { label: t("contactDirectory.contact_directory"), class: 'sub-menu search-sub-menu', url: "/contact-directory.html", linkTag: true },
            { label: t("businessDirectory.marketplace"), class: 'sub-menu search-sub-menu', url: "/site-search-results.html", linkTag: true },
        ],
        class: 'main-menu search-button',
    },
    { label: 'Enterprise', class: 'main-menu enterprise-column', url: enterpriseURL },
    { label: 'D‑U‑N‑S Number', class: 'main-menu duns-menu', url: dunsNumberMythsURL },
    { label: 'Business Credit', class: 'main-menu duns-menu', url: businessCreditURL },
    { label: 'Business Growth', class: 'main-menu duns-menu', url: businessGrowthURL },
    { label: 'Business Risk', class: 'main-menu duns-menu', url: businessRiskURL },
    { label: 'Resources', class: 'main-menu duns-menu lastChild', url: resourcesHeaderURL },
    { label: 'D‑U‑N‑S Number', class: 'main-menu business-menu dunsNumberMenu', url: dunsNumberURL },
    { label: 'Business Directory', class: 'main-menu business-menu', url:"/", linkTag: true },
    { label: 'Service Center', class: 'main-menu business-menu', url: serviceCenterURL},
    {
        label: 'Log In',
        class: 'main-menu business-menu login-menu',
        children: [
            {
                label: loginMenuLinks['us'].headingDnbProduct,
                class: "sub-menu",
                children: loginMenuLinks['us'].dnbProductsData.map(item => ({
                    label: item.linkName,
                    url: item.url,
                    onNewTab: item.onNewTab,
                    class: "sub-menu",
                })),
            },
            {
                label: loginMenuLinks['us'].headingMyCompanyInfo,
                class: "sub-menu",
                children: loginMenuLinks['us'].myCompanyInfoData.map(item => ({
                    label: item.linkName,
                    url: item.url,
                    onNewTab: item.onNewTab,
                    class: "sub-menu",
                })),
            },
        ]
    },
    { label: '', class: 'main-menu business-menu globe-icon-menu', url: globeHeaderIconURL },
];

const HeaderMobileComponent = (): JSX.Element => {
    const { t } = useTranslation();
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [menuStack, setMenuStack] = useState<MenuItem[][]>([menuData]);
    const homeRedirection = t("homeRedirection");

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
        if (!isNavOpen) setMenuStack([menuData]);
    };

    const handleItemClick = (item: MenuItem) => {
        if (item.children) {
            setMenuStack(prev => [...prev, item.children!]);
        }
    };

    const handleBack = () => {
        if (menuStack.length > 1) {
            setMenuStack(prev => prev.slice(0, -1));
        }
    };

    const currentMenu = menuStack[menuStack.length - 1];

    return (
        <>
            {/* {useMinifiedHeaderBoolean ? (
                <></>
            ) : ( */}
            <div className="mobile-header-container">
                <div className="header-bar">
                    <div className="logo"> 
                        <Link
                            aria-label="Homepage link"
                            className="consolidatedMinifiedHeaderLogoLink"
                            to={homeRedirection}
                        >
                            <img
                                alt="D&B logo"
                                className="consolidatedHeaderLogo"
                                src={homepageLogo}
                            />
                        </Link>
                    </div>
                    <button className="menu-toggle" onClick={toggleNav}>
                        <img alt="Menu toggle button" src={isNavOpen ? mobileCloseButton : mobileToggleButton} />
                    </button>
                </div>

                <div className={`mobile-menu ${isNavOpen ? 'open' : ''}`}>
                    <div className="menu-content">
                        {menuStack.length > 1 && (
                            <button className="back-button" onClick={handleBack}>
                                <ChevronLeftSvg /> {menuStack.length === 2 && (<span>Main Menu</span> )}
                            </button>
                        )}
                        <ul className="menu-list">
                            {currentMenu.map((item, idx) => (
                                <li key={idx} onClick={() => handleItemClick(item)} className={item?.class}>
                                    {item?.class?.includes('search-button') && <>
                                        <span className="search-icon"></span>
                                        {item.label}
                                    </>}
                                    {item?.class?.includes('enterprise-column') && <>
                                        <a className="enterprise-link inactive-link enterprise" href={item?.url}>{item.label}</a>
                                        <Link to="/">Small Business</Link>
                                        <a className="inactive-link" href={publicSectorURL}>Public Sector</a>
                                    </>}
                                    {item?.class?.includes('duns-menu') && <>
                                        <a className="consolidatedHeaderLink" href={item?.url}>{item.label}</a>
                                    </>}
                                    {item?.class?.includes('business-menu') && <>
                                        {item?.class?.includes('login-menu') && <span className="login-icon"></span>}
                                        {item?.class?.includes('globe-icon-menu') && <span className="globe-icon"></span>}
                                        {item?.linkTag === true && item?.url ? (<Link to={item?.url} onClick={toggleNav}>{item.label}</Link>) : (<a href={item?.url}>{item.label}</a>)}
                                    </>}
                                    {item?.class?.includes('sub-menu') && <>
                                        {item?.linkTag === true && item?.url ? (<Link className="consolidatedHeaderLink" to={item?.url} onClick={toggleNav}>{item.label}</Link>) : (<a className="consolidatedHeaderLink" href={item?.url}>{item.label}</a>)}
                                    </>}
                                    {item.children && <span className="arrow"></span>}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {isNavOpen && <div className="overlay" onClick={toggleNav} />}
            </div >
        </>
    )
}

export default HeaderMobileComponent;
